import React from "react";
import { BaseListing } from "../../common/BaseListing";
import { DateHelper } from "../../../common/Helpers";
import { Link } from "react-router-dom";
import { AllowedTiming } from "../../../constants/PricingConstants";
import { LocationBrandsEnum } from "../../../common/Constants";
import { LocationBrand } from "../../../constants/MovieConstants";
import { FieldWrapper } from "../../campaigns/FieldWrapper";
import RestClient from "../../../common/RestClient";
import { toast } from "react-toastify";
import {
  NavigationItem,
  NavigationSettings,
} from "../../common/NavigationSettings";
import { CustomSelect } from "../../common/CustomSelect";
import { isEmpty } from "../../../common/Common";
import { MovieFormat } from "../../../constants/MovieConstants";
import {
  AuthenticationManager,
  ResourceID,
} from "../../../common/AuthenticationManager";
import ButtonActionDetailGroup from "../../common/ButtonActionDetailGroup";

export class SpecialPriceListing extends BaseListing {
  constructor() {
    super();
    this.state = {
      search: "",
      movieReleaseSelectors: [],
      serviceSelectors: [],
      movieReleaseId: 0,
      serviceId: 0,
      allowedLocationBrands: 0,
      allowedTiming: 0,
    };
  }

  getNavigationSettings = () => {
    return new NavigationSettings({
      parentModule: new NavigationItem({
        identifier: "pricing",
        name: "Pricing",
      }),
      activeModule: new NavigationItem({
        identifier: "special_prices",
        name: "SpecialPrice",
      }),
    });
  };

  getApiPath = () => "/api/v1/special_prices";

  getDefaultSort = () => "-CreatedOn";

  injectSearchTerm(queryParameters) {
    const { movieReleaseId, serviceId, allowedLocationBrands, allowedTiming, search } =
      this.state;
    const request = {
      includes: "MovieRelease,Service",
    };
    request.movieReleaseId = movieReleaseId;
    request.serviceId = serviceId;
    request.allowedLocationBrands = allowedLocationBrands;
    request.allowedTiming = allowedTiming;
    request.search = search;
    return super.injectSearchTerm(queryParameters, request);
  }

  onSelectChange = async (e, name) => {
    const value = isEmpty(e.value) ? 0 : e.value;
    this.setState({ [name]: value }, () => {
      const {
        movieReleaseId,
        serviceId,
        allowedLocationBrands,
        allowedTiming,
      } = this.state;
      const params = {
        movieReleaseId,
        serviceId,
        allowedLocationBrands,
        allowedTiming,
      };
      const normalized = Object.fromEntries(
        Object.entries(params).filter(([, v]) => {
          if (!Number.isNaN(+v)) {
            return +v > 0;
          }
          return !isEmpty(v);
        })
      );
      const additionalParams = new URLSearchParams(normalized).toString();
      this.props.history.push(`special_prices?${additionalParams}`);
      this.resetPageBounds();
      this.loadData(0);
    });
  };

  componentDidMount() {
    this.loadMovieReleaseSelectors();
    this.loadServiceSelectors();
  }

  getQueryParamValue = (queryParam) => {
    const url = new URL(window.location.href);
    return url.searchParams.get(queryParam);
  };
  parseQueryParamValue = (queryParam, selectors) => {
    const value = this.getQueryParamValue(queryParam);
    const found = selectors.filter((x) => x.Id === value);
    if (!found) {
      return "";
    }
    return value;
  };

  parseId = (value) => {
    if (!value) {
      return 0;
    }
    return parseInt(value);
  };

  loadMovieReleaseSelectors = () => {
    RestClient.sendGetRequest(
      "/api/v1/movie_releases/options",
      (response) => {
        const movieReleaseId = this.parseId(
          this.parseQueryParamValue("movieReleaseId", response.data)
        );
        const allowedLocationBrands = +this.getQueryParamValue(
          "allowedLocationBrands"
        );
        const allowedTiming = +this.getQueryParamValue("allowedTiming");
        this.setState(
          {
            movieReleaseSelectors: response.data,
            movieReleaseId,
            allowedLocationBrands,
            allowedTiming,
          },
          () => this.loadData(0)
        );
      },
      (error) => {
        toast.error(error.message);
      }
    );
  };

  loadServiceSelectors = () => {
    RestClient.sendGetRequest(
      "/api/v1/services",
      (response) => {
        const serviceId = this.parseId(
          this.parseQueryParamValue("serviceId", response.data)
        );
        const data = response.data.map((x) => {
          return { id: x.id, code: x.code, name: `${x.code} - ${x.name}` };
        });
        this.setState({ serviceSelectors: data, serviceId });
      },
      (error) => {
        toast.error(error.message);
      }
    );
  };

  generateTableContent() {
    const { data } = this.state;
    return (
      <>
        <thead>
          <tr>
            <th>ID</th>
            <th>Movie Release</th>
            <th>Service</th>
            <th>Start On</th>
            <th>End On</th>
            <th>Allowed Location Brands</th>
            <th>Allowed Timing</th>
            <th>
              Created On
              <i
                className="fas fa-sort-alpha-down"
                id="CreatedOn"
                onClick={this.toggleSort}
              />
            </th>
          </tr>
        </thead>
        <tbody>
          {data &&
            data.map((item, index) => {
              return (
                <tr key={index} onClick={() => this.onRowClick(item.id)}>
                  <td>{item.id}</td>
                  <td>
                    {item.movieRelease.primaryTitle}-{item.movieRelease.id}-$
                    {MovieFormat.getName(item.movieRelease.format)}
                  </td>
                  <td>
                    {item.service.code}-{item.service.name}-{item.service.id}
                  </td>
                  <td>{DateHelper.formatDateTimeString(item.startOn)}</td>
                  <td>{DateHelper.formatDateTimeString(item.endOn)}</td>
                  <td>
                    {LocationBrandsEnum.getLocationBrand(
                      item.allowedLocationBrands
                    )}
                  </td>
                  <td>{AllowedTiming.getName(item.allowedTiming)}</td>
                  <td>{DateHelper.formatDateTimeString(item.createdOn)}</td>
                </tr>
              );
            })}
        </tbody>
      </>
    );
  }

  generateExtendedComponents() {
    return (
      <ButtonActionDetailGroup>
        {AuthenticationManager.isAuthorized(
          ResourceID.SpecialPricingCreateButtonAndPage
        ) && (
            <ButtonActionDetailGroup.Item>
              <Link
                className="btn btn-primary d-block"
                to="/special_prices/create"
                style={{ fontSize: "1rem" }}
              >
                <i className="fas fa-plus-circle" /> Create New Special price
              </Link>
            </ButtonActionDetailGroup.Item>
          )}
      </ButtonActionDetailGroup>
    );
  }

  generateTableFilter() {
    const {
      movieReleaseSelectors,
      serviceSelectors,
      movieReleaseId,
      serviceId,
      allowedTiming,
      allowedLocationBrands,
    } = this.state;
    return (
      <>
        <div className="row mb-3">
          <div className="col-md-6 form-group">
            <FieldWrapper
              label="Movie Release"
              input={
                <CustomSelect
                  data={movieReleaseSelectors}
                  label="name"
                  value="id"
                  onChange={(e) => this.onSelectChange(e, "movieReleaseId")}
                  selectedValue={movieReleaseId}
                  allowEmpty={true}
                />
              }
            />
          </div>
          <div className="col-md-6 form-group">
            <FieldWrapper
              label="Service"
              input={
                <CustomSelect
                  data={serviceSelectors}
                  label="name"
                  value="id"
                  onChange={(e) => this.onSelectChange(e, "serviceId")}
                  selectedValue={serviceId}
                  allowEmpty={true}
                />
              }
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <FieldWrapper
              label="Allowed Location Brands"
              input={
                <CustomSelect
                  data={LocationBrand.All}
                  label="name"
                  value="value"
                  onChange={(e) =>
                    this.onSelectChange(e, "allowedLocationBrands")
                  }
                  selectedValue={allowedLocationBrands}
                />
              }
            />
          </div>
          <div className="col-md-6 form-group">
            <FieldWrapper
              label="Allowed Timing"
              input={
                <CustomSelect
                  data={AllowedTiming.All}
                  label="name"
                  value="value"
                  onChange={(e) => this.onSelectChange(e, "allowedTiming")}
                  selectedValue={allowedTiming}
                />
              }
            />
          </div>
        </div>
        <div className="row mb-3">
          <div className="col row" />
          <div className="col-md-6 input-group ml-auto">
            <input
              type="text"
              id="input1-group2"
              name="name"
              placeholder="Enter key word"
              className="form-control"
              onKeyDown={this.onKeyDownSearchInput}
              onChange={(e) => this.setState({ search: e.target.value })}
            />
            <div className="input-group-btn">
              <button className="btn btn-primary" onClick={this.search}>
                <i className="fa fa-search" aria-hidden="true" /> Search
              </button>
            </div>
          </div>
        </div>
      </>
    );
  }
}
